import useSWR from "swr";

import { getAdminProducts } from "../services/order.service";
import { SWRType } from "../types/global";
import { ProductFilters } from "../types/order";

const useCrmProducts = (autoFetch = false, filters: ProductFilters = {}) => {
  const {
    data,
    isLoading: dataLoading,
    mutate,
    error,
  }: SWRType = useSWR(
    autoFetch ? ["crm-admin-products", filters] : null,
    ([, queryParams]) =>
      getAdminProducts({
        ...queryParams,
        ...(Array.isArray(queryParams?.sort) && queryParams.sort.length > 0
          ? { sort: queryParams.sort.join(",") }
          : {}),
      } as any),
    {
      onErrorRetry: (fetchError) => {
        if (fetchError.status === 404) return;
      },
    },
  );

  return {
    data,
    dataLoading,
    mutate,
    error,
  };
};

export default useCrmProducts;
